/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';

const ruleMap = {
  isMobile: {
    ctxName: 'channel',
    expectedValue: 'mobile'
  },
  isDesktop: {
    ctxName: 'channel',
    expectedValue: 'desktop'
  },
  isConsumerApp: {
    ctxName: 'isConsumerApp',
    expectedValue: true
  }
};

export function withExpContextRule(BaseComponent, opts = {}) {

  function ExpContextRule(props) {

    const {
      renderRules: renderRulesProp = [],
      propRules: propRulesProp = {},
    } = props;

    const ctx = useContext(ExperienceContext);

    const renderRules = [...renderRulesProp];

    const propRules = {
      ...propRulesProp
    };

    if (opts.render) {
      if (ctx) {
        const mappedRule = ruleMap[opts.render.name];
        const matchedValue = ctx[mappedRule.ctxName] === mappedRule.expectedValue;
        renderRules.push(opts.render.negate ? !matchedValue : matchedValue);
      } else {
        console.warn('Experience Context Not Defined');
      }
    }

    if (opts.prop) {
      if (ctx) {
        const mappedRule = ruleMap[opts.prop.name];
        const matchedValue = ctx[mappedRule.ctxName] === mappedRule.expectedValue;
        propRules[opts.prop.alias || opts.prop.name] = opts.prop.negate ? !matchedValue : matchedValue;
      } else {
        console.warn('Experience Context Not Defined');
      }
    }

    return (
      <BaseComponent {...props} renderRules={renderRules} propRules={propRules} />
    );

  }

  ExpContextRule.displayName = 'ExpContextRule';

  ExpContextRule.dataModel = {};

  return ExpContextRule;
}